import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Head from '../../layout/head/Head';
import Content from '../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../components/Component';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { useSelector } from 'react-redux';
import { fail_retrieve_sales_rep_tenant_order_list, loading_retrieve_sales_rep_tenant_order_list, reset_retrieve_sales_rep_tenant_order_list, success_retrieve_sales_rep_tenant_order_list } from '../../reducers/auth_tenant/retrieve_sales_rep_tenant_order_list_Slice';
import * as app_consts from "../../utils/app_consts";
import { RETRIEVE_TENANT_ORDERS_LIST_ERROR_MSG, RETRIEVE_TENANT_ORDERS_LIST_SUCCESS_MSG } from '../../utils/error_success_messages';
import { formatToSentenceCase, messageToast } from '../../utils/Utils';
import { Link } from 'react-router-dom';
import AuthTenantLoader from '../loaders/AuthTenantLoader';
import AuthTenantPageError from '../error/AuthTenantPageError';
import { RETRIEVE_SALES_REP_TENANT_ORDERS_LIST_API } from '../../api/api_data';
import AuthTenantNoData from '../error/AuthTenantNoData';
import { Badge } from 'reactstrap';
import moment from 'moment';
import CardTabs from '../components/cards/CardTabs';
import MyOrders from './order_data/MyOrders';
import AllOrders from './order_data/AllOrders';

const OrderListings = ({ tenant_info, user_info }) => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [sm, updateSm] = useState(false);
  const [itemPerPage] = useState(10);
  const [page_data, setPageData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeCardTab, setActiveCardTab] = useState("My Orders");

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    retrieve_orders();
  }, []);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate the start and end index for the current page
  const startIndex = (currentPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;

  // UseEffect for Search 
  useEffect(() => {
    filtered_orders(searchTerm);
  }, [searchTerm]);

  const filtered_orders = (searchItem) => {
    if (searchItem)
    {
      let displayedOrders;

      displayedOrders = page_data?.filter((item) => {
        const combinedParams = [
          item.order_ref_number,
          item.order_name,
          item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
          item.status?.replace(/_/g, ' ').toUpperCase(),
        ]
          .join(" ")
          .toLowerCase();

        return combinedParams.includes(searchItem.toLowerCase());
      }).slice(startIndex, endIndex);

      setCurrentPageData(displayedOrders);
    } else
    {
      setCurrentPageData(page_data);
    }
  };


  const retrieve_orders = () => {
    setError("");
    // Retrieve Products
    dispatch(tenant_auth_actions_helper(loading_retrieve_sales_rep_tenant_order_list, success_retrieve_sales_rep_tenant_order_list, fail_retrieve_sales_rep_tenant_order_list, RETRIEVE_TENANT_ORDERS_LIST_ERROR_MSG, RETRIEVE_TENANT_ORDERS_LIST_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_SALES_REP_TENANT_ORDERS_LIST_API}`));
  };

  // Listen
  const retrieve_retrieve_sales_rep_tenant_order_list = useSelector((state) => state.retrieve_sales_rep_tenant_order_list.retrieve_sales_rep_tenant_order_list);

  useEffect(() => {
    if (retrieve_retrieve_sales_rep_tenant_order_list.status !== app_consts.IDLE)
    {
      if (retrieve_retrieve_sales_rep_tenant_order_list.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_retrieve_sales_rep_tenant_order_list.status === app_consts.FAIL)
        {
          setError(retrieve_retrieve_sales_rep_tenant_order_list.message);
          messageToast(retrieve_retrieve_sales_rep_tenant_order_list.message, app_consts.FAIL);
        } else if (retrieve_retrieve_sales_rep_tenant_order_list.status === app_consts.SUCCESS)
        {
          setCurrentPageData(retrieve_retrieve_sales_rep_tenant_order_list.data);
          setPageData(retrieve_retrieve_sales_rep_tenant_order_list.data);
        }
        dispatch(reset_retrieve_sales_rep_tenant_order_list());
      }
    }
  }, [retrieve_retrieve_sales_rep_tenant_order_list]);

  const tabs = [
    {
      tabName: "My Orders", icon: "package-fill"
    }
  ];

  if ((user_info?.is_approver))
  {
    tabs?.push({ tabName: "All Orders", icon: "bag-fill" });
  }

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Order` : "Orders"} />
      <Content>
        <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
        {
          activeCardTab === "My Orders" && (
            <>
              <MyOrders tenant_info={tenant_info} user_info={user_info} />
            </>
          )
        }
        {
          activeCardTab === "All Orders" && (
            <>
              <AllOrders tenant_info={tenant_info} user_info={user_info} />
            </>
          )
        }
      </Content>

    </>
  );
};

export default OrderListings;